import TotalAuditsCompleted from './TotalAuditsCompleted';
export default TotalAuditsCompleted;
